import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=33cb2fe8&"
import script from "./Recordings.vue?vue&type=script&lang=ts&"
export * from "./Recordings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports